module.exports = __webpack_public_path__ + "etcnstatic/img/tax2.6cd50b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/tax2.png
// module id = dRpi
// module chunks = 1